import React from "react";
import { Button as BootstrapButton } from "react-bootstrap";
import { MdArrowBack } from "react-icons/md";
import { useNavigate } from "react-router-dom";

interface BackButtonProps {
  navigateTo?: string;
  onClick?: () => void;
  className?: string;
}

const BackButton: React.FC<BackButtonProps> = ({
  navigateTo = "/",
  onClick,
  className = "rounded-pill m-2",
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(navigateTo);
    }
  };

  return (
    <BootstrapButton
      type="button"
      className={`custom-button ${className}`}
      onClick={handleClick}
      variant="outline-primary"
      style={{
        backgroundColor: "transparent",
        borderColor: "#214382",
        color: "#214382",
        display: "flex",
        alignItems: "center",
        gap: "0.3rem",
      }}
    >
      <MdArrowBack size={18} />
      Back
    </BootstrapButton>
  );
};

export default BackButton;
